import React, { PureComponent } from 'react';

import { LocaleContext } from 'context/LocaleContext';

import Placeholder from './placeholders/document.placeholder';

export default class GoogleDoc extends PureComponent {
    static contextType = LocaleContext;

    state = {
        loaded: false
    };

    resizeListener = () => {
        this.resizeElement();
    }

    resizeElement() {
        if (!this.element) {
            return;
        }

        this.element.style.height = `${this.element.parentElement.clientHeight}px`;
    }

    handleLoad = () => {
        this.setState({
            loaded: true
        });
    }

    setRef = element => this.element = element;

    componentDidMount() {
        this.resizeElement();

        window.addEventListener('resize', this.resizeListener);
    }

    componentDidUpdate() {
        this.resizeElement();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener)
    }

    render() {
        const docType = this.props.docType === 'spreadsheet' ? 'spreadsheets' : this.props.docType;

        return (
            <React.Fragment>

                {
                    !this.state.loaded ? <Placeholder /> : null
                }

                <iframe
                    ref={this.setRef}
                    className={'google-doc' + (!this.state.loaded ? ' loading' : '')}
                    title="Google Doc"
                    width="100%"
                    height="100%"
                    name="google-doc-disable-x-frame-options"
                    src={`https://docs.google.com/${docType}/d/${this.props.googleId}?hl=${this.context.language}`}
                    onLoad={this.handleLoad}
                />
            </React.Fragment>
        );
    }
}
